import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/jd.jpg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> NIYOKWIZERA JEAN D AMOUR</strong>
              </h1>

              <div className="hero-ribbon">Building useful software, AI products, and delightful web experiences.</div>

              <div className="typewriter-wrap">
                <Type />
              </div>
            </Col>

            <Col md={5} className="hero-image-col">
              <div className="hero-visual-wrap">
                <span className="hero-orb hero-orb-1"></span>
                <span className="hero-orb hero-orb-2"></span>
                <img
                  src={homeLogo}
                  alt="NIYOKWIZERA profile"
                  className="img-fluid hero-main-image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
